import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './config/appConfig';

async function bootstrap() {
    try {
        await loadConfig();

        const root = ReactDOM.createRoot(
            document.getElementById('root')
        );

        root.render(
                <App />
        );
    } catch (error) {
        console.error('Erro ao inicializar a aplicação:', error);

        document.body.innerHTML = `
      <div style="padding: 20px; font-family: sans-serif;">
        <h2>Erro ao carregar a aplicação</h2>
        <p>Configuração não pôde ser carregada.</p>
      </div>
    `;
    }
}

bootstrap();

reportWebVitals();
